import type { MouseEventHandler } from 'react'
import { useIntl } from 'react-intl'

import { Button } from '@components/ui/Buttons'
import { MailOutlineIcon } from '@components/ui/svgIcons'

import { messages as formMessages } from '@components/forms/MessageToAccountantForm/messages'
import { StyledIconButton } from './styles'

interface MessageToAccountantButtonProps {
  className?: string
  isCompact?: boolean
  isDesktop?: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
}

export function MessageToAccountantButton({
  className,
  isCompact = false,
  isDesktop = false,
  onClick,
}: MessageToAccountantButtonProps) {
  const { formatMessage } = useIntl()

  return isDesktop ? (
    <StyledIconButton
      className={className}
      onClick={onClick}
      title={formatMessage(formMessages.title)}
      data-testid="message-to-accountant-btn"
      $isCompact={isCompact}
    >
      <MailOutlineIcon />
    </StyledIconButton>
  ) : (
    <StyledIconButton
      as={Button}
      className={className}
      onClick={onClick}
      data-testid="message-to-accountant-btn"
      $isCompact={isCompact}
    >
      {formatMessage(formMessages.title)}
    </StyledIconButton>
  )
}
